export default "__VITE_ASSET__Dl92U2pa__"